import dynamic from 'next/dynamic';
import { LottieComponentProps } from 'lottie-light-react';

const DynamicLottie = dynamic(() => import('lottie-light-react'), {
  ssr: false,
});

const Lottie = (props: LottieComponentProps) => {
  return <DynamicLottie {...props} />;
};

export default Lottie;
